import { useEffect, useCallback } from 'react';
import { createPortal } from 'react-dom';

const Modal = ({open, setOpen, close, className, children}:any) => {
    function closeModal() {
        close && close()
        setOpen(false)
    }

    const escFunction = useCallback((e:any) => {
        if (e.key === "Escape") closeModal()
    }, [open])

    useEffect(() => {
        if (open) {
            document.addEventListener("keydown", escFunction, false);
            return () => document.removeEventListener("keydown", escFunction, false)
        }
    }, [escFunction])

    useEffect(() => {
        if (open) {
            document.body.classList.add('modal-open');
            document.getElementById('root')?.classList.add('modal-open');
        } else {
            document.body.classList.remove('modal-open');
            document.getElementById('root')?.classList.remove('modal-open');
        }
    }, [open])

    return createPortal(
        <div className={open ? 'modal active':'modal'}>
            <div className="modal_wrap">
                <div className={`modal_content ${className || ''}`}> 
                    {children}
                </div>
            </div>
            <div className="modal_close" onClick={e => closeModal()}></div>
        </div>,
        (document.getElementById('modal')!)
    );
};

export default Modal;